import styled from 'styled-components';

import { HOME, HOME_NARROW } from '../../../../theme/tokens';
import { pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** Leaderboards side by side (one column per board), collapsing to one column at
 *  1120px. `$cols` tracks the number of boards so a lone board (e.g. only Top Players
 *  while Top Games is gated off) spans the full width instead of leaving a gap. */
export const Grid = styled.div<{ $cols: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $cols }) => $cols}, minmax(0, 1fr));
  gap: 10px;

  ${HOME_NARROW} {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  ${pulseCard}
  padding: 14px 16px;
  min-width: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 6px;
  border-bottom: 1px solid ${HOME.hairline};
`;

export const HeadPrimary = styled(Text)`
  font-size: 15px;
  font-weight: 700;
  color: ${HOME.t300};
`;

export const HeadSecondary = styled(Text)`
  font-size: 13px;
  font-weight: 400;
  color: ${HOME.t500};
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 9px 0;

  & + & {
    border-top: 1px solid ${HOME.hairline};
  }
`;

export const Rank = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${HOME.t500};
  font-variant-numeric: tabular-nums;
`;

export const Name = styled(Text)`
  font-size: 15px;
  font-weight: 500;
  color: ${HOME.t100};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Value = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${HOME.t50};
`;

/** Shown in place of the rows when a resolved board has none (empty range or error). */
export const Empty = styled(Text)`
  display: block;
  padding: 22px 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: ${HOME.t500};
  text-align: center;
`;
